import React from 'react';

import styles from './styles.module.css';

const OverlayAvatars = ({ avatars, width, height }) => (
  <div className={styles.avatars}>
    {avatars.map((avatarUrl) => (
      <span className={styles.avatar} key={avatarUrl}>
        <img src={avatarUrl} width={width || 24} height={height || 24} />
      </span>
    ))}
  </div>
);

export default OverlayAvatars;
